import { render } from "./NgpVanIntegration.vue?vue&type=template&id=361d0658&scoped=true"
import script from "./NgpVanIntegration.vue?vue&type=script&lang=js"
export * from "./NgpVanIntegration.vue?vue&type=script&lang=js"

import "./NgpVanIntegration.vue?vue&type=style&index=0&id=361d0658&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361d0658"]])

export default __exports__